<template>
    <div class="relative z-50">
        <div>
            <div class="relative z-50">
                <div>
                  <input
                    v-model="inputData"
                    @focus="option = true"
                    @blur="onBlur"
                    :placeholder="placeholder"
                    type="text"
                    class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold w-full outline-none"
                  />
                </div>
                <!-- Dropdown list -->
                <div v-show="option && filteredOptions.length" class="absolute w-full bg-white border rounded-md mt-1 shadow-lg z-10">
                  <div
                    v-for="(option, index) in filteredOptions"
                    :key="index"
                    class="py-3 px-3 text-sm hover:bg-[#e9e9e9] text-[#6d6b6b] border-b border-gray-200"
                    @click="getValue(option.key, option.value)">
                    {{ option.value }}
                  </div>
                </div>
              </div>
        </div>
    </div>
  </template>
  
  <script>
  import { defineComponent } from 'vue'
  
  export default defineComponent({
    data() {
      return {
        option: false,  // For showing/hiding the options
        inputData: "",  // The input value
        placeholder: "Type to Search Employee",
      }
    },
    props:{
        suggestions:{
            type: Array,
            default:()=>[
            { key: "TEST1", value: "LHAN ZELL OBLIDA REYES" },
            { key: "TEST2", value: "LEBRON JAMES" },]
        }
    },
    computed: {
      // Filter suggestions based on the input data
      filteredOptions() {
        if(this.suggestions.length){
          return this.suggestions.filter(suggestion => 
            suggestion.key.toLowerCase().includes(this.inputData.toLowerCase()) || 
            suggestion.value.toLowerCase().includes(this.inputData.toLowerCase())
        ).slice(0, 5);
        }
        else{
            return null;
        }
      
      }
    },
    methods: {
      onBlur() {
        setTimeout(() => {
          this.option = false;
        }, 200);  
      },
 
      getValue(key,value) {
        this.inputData = value;  // Update the input field with the selected option
        this.option = false;  // Hide the dropdown after selection
        this.$emit("getEmpKey", key , value)
    
      }
    },
  })
  </script>
  